import { mostrarPrecio, redondeo } from '@/utils/funciones_auxiliares.js';
export default {
	continuarPedidoBool(state) {
		return state.continuarPedido &&
			state.carrito &&
			state.carrito.numero_producto > 0

	},
	restaurantePedidoObj(state, getters, rootState) {
		const rest = state.restaurantePedido;
		const negocio = state.negocioPedido
		return rootState.restaurante.listadoRestaurantes.find(r => r.id == rest)
	},
	productosPedido: state => {
		if (state.activePedido && state.activePedido.hasOwnProperty('total')) {
			return state.activePedido.total;
		} else {
			return 0;
		}
	},
	precioPedido(state) {
		if (state.activePedido && state.activePedido.hasOwnProperty('total')) {
			return state.activePedido.total;
		} else {
			return 0;
		}
	},
	productDialog(state) {
		return state.activeProduct.dialog;
	},
	getCurrentDialogOpciones(state) {                                                        //Devuelve las opciones del nuevo Dialog
		let res = 'Sin Opciones';
		let condicionOpciones = state.activeProduct.tieneOpciones && state.activeProductDialogActivo != null && state.opcionesActiveProduct && Array.isArray(state.opcionesActiveProduct);
		let posicionEnModalDeOpciones = state.activeProductDialogActivo;

		if (condicionOpciones) {

			res = state.activeProduct.opciones[posicionEnModalDeOpciones]

		}
		//Cambiar la condicion de retroceso para establecerla como estaba antes, sin filtros quizas
		return res;


	},
	isLastDialog(state) {
		if (state.opcionesActiveProduct) {
			return (state.opcionesActiveProduct.length - 1) == state.activeProductDialogActivo;
		} else {
			return true;
		}

	},
	calculoImpuestosCarrito(state, getters, rootState) {
		let precio = 0;
		let modo = rootState.config.modoFuncionamiento;

		state.carrito.productos.forEach((e) => {
			let impuesto = e.impuesto;
			let opciones = e.opcionesPrecio;
			let precioOpciones = 0;

			if (opciones.length > 0) {
				const reducer = (accumulator, currentValue) =>
					accumulator + currentValue;
				precioOpciones = opciones.reduce(reducer);
			}
			let precioProducto = (parseFloat(e.precio) + precioOpciones) * e.cantidad;
			let base = precioProducto / (1 + parseFloat(impuesto));
			precio += (precioProducto - base);
		})
		return redondeo(precio);
	},
	calculoImpuestosUltimoPedido(state) {
		let precio = 0;
		let modo = state.ultimoPedido.modo;

		state.ultimoPedido.productos.forEach((e) => {
			let impuesto = e.impuesto;
			let opciones = e.opcionesPrecio;
			let precioOpciones = 0;

			if (opciones.length > 0) {
				const reducer = (accumulator, currentValue) =>
					accumulator + currentValue;
				precioOpciones = opciones.reduce(reducer);
			}
			let precioProducto = (parseFloat(e.precio) + parseFloat(precioOpciones)) * e.cantidad;
			let base = precioProducto / (1 + parseFloat(impuesto));
			precio += (precioProducto - base);
		})
		return precio;
	},
	isFirstDialog(state) {
		if (state.opcionesActiveProduct) {
			return state.activeProductDialogActivo == 0 && state.opcionesActiveProduct.length >= 1;
			// return state.activeProductDialogActivo == 0 && state.opcionesActiveProduct.length > 1;
		} else {
			return true;
		}
	},
	isUniqueDialog(state) {
		if (state.opcionesActiveProduct) {
			return state.activeProductDialogActivo == 0 && state.opcionesActiveProduct.length < 2;
			// return state.activeProductDialogActivo == 0 && state.opcionesActiveProduct.length == 0;
		} else {
			return true;
		}
	},
	cambioEfectivo(state) {

		let billetes = [5, 10, 20, 50, 100];
		let cambios = [];
		let precioCarrito = state.carrito.precio_total ? state.carrito.precio_total : 0;
		let impuestoCarrito = state.carrito.impuesto_aplicado ? state.carrito.impuesto_aplicado : 0;
		let precioTotal = precioCarrito + impuestoCarrito;

		billetes.forEach(function (e) {
			let cont = 0;
			let temp = e * cont;
			while (temp <= precioTotal) {
				cont++;
				temp = e * cont;
			}
			cambios.includes(temp) || temp - e >= precioTotal ? null : cambios.push(temp);
			billetes.forEach(function (e2) {                              //comprobación de billetes combinados a pares
				let temp2 = e + e2;
				if (!cambios.includes(temp2) && temp2 > precioTotal && temp2 - e2 < precioTotal && temp2 - e < precioTotal) {
					cambios.push(temp2)
				}
				billetes.forEach(function (e3) {                              //comprobación de billetes combinados a pares
					let temp3 = e + e2 + e3;
					if (!cambios.includes(temp3) && temp3 > precioTotal && temp3 - e3 < precioTotal && temp3 - e2 < precioTotal && temp3 - e < precioTotal) {
						cambios.push(temp3)
					}
					billetes.forEach(function (e4) {                              //comprobación de billetes combinados a pares
						let temp4 = e + e2 + e3 + e4;
						if (!cambios.includes(temp4) && temp4 > precioTotal && temp4 - e4 < precioTotal && temp4 - e3 < precioTotal && temp4 - e2 < precioTotal && temp4 - e < precioTotal) {
							cambios.push(temp4)
						}
					})
				})
			})
		})
		/*
		cambios.forEach(function(e, index, arr){
			let btn         = '<div class="col p-1 disabledbtnCambio" onclick="enableOrNotCambio(this)"><button class="btn btn-warning btn-block btn-mewo btn-sm py-2 btnCambio">'+e+' €</button></div>';
			$(".cambioNeeded").append(btn)
		})
		*/
		return cambios;

	},
	esDomicilio(state) {
		return (state.activePedido) ? state.activePedido.forma_envio == "domicilio" : false
	},
	activeProductConPrecioNeo(state) {
		let prod = state.activeProduct;

		if (state.activeProduct.id != undefined) {

			if (prod.precioNeo == undefined || prod.precioNeo == 0 && prod.opciones.length > 0) {
				for (var i = 0; i <= prod.opciones.length; i++) {
					let precioOpciones = prod.opciones[i].opciones;
					let precioBaseArray = precioOpciones.map((e) => {
						return e.mapeoNeoPrecio != undefined && e.mapeoNeoPrecio > 0 ? e.mapeoNeoPrecio : 0;
					});
					let sinCeros = precioBaseArray.filter((e) => {
						return e > 0;
					});

					if (sinCeros.length > 0) {
						prod.precioNeo = Math.min.apply(Math, sinCeros)
						i = prod.opciones.length;
					}
				}
			}
		}

		return prod;
	},
	resumenUltimoPedido(state) {
		let u = state.ultimoPedido;
		return u;
	}
}